export default {
  app_name: "Tank Diameter",
  baseUrl:"http://3.134.98.180:8085"
};